import mutations from './employabilityReport.mutations'
import actions from './employabilityReport.actions'
import getters from './employabilityReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
